module.exports = __webpack_public_path__ + "static/media/trash.b2b775f2.svg";